export default __webpack_public_path__ + "static/slide_bg-86deee67f5205b83ae4c262581fccec7.png";